export default "__VITE_ASSET__3bc349c5__"